import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import uiActions from '../../actions/UIActions';
import storeManager from '../../store/StoreManager';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';

class OptionsHideTimeRemaining extends React.Component {
    static propTypes = {
        ui: PropTypes.object,
    };

    /**
     * @param {string} newValue: 'on' or 'off';
     * */
    handleChange = (newValue) => {
        storeManager.dispatch(
            uiActions.uiHideTimeRemaining(newValue === 'hide')
        );
    };

    render() {
        const { ui } = this.props;
        const current = ui.timeRemainingHidden ? 'hide' : 'show';
        const choices = ['show', 'hide'].map((option) => {
            return {
                identifier: option,
                title: t(`general.${option}`),
                isSelected: current === option,
            };
        });

        return (
            <div>
                <OptionsTopBar title={t('options.hideTimeRemainingTitle')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.handleChange}
                        choices={choices}
                    />
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        ui: state.ui,
    };
}

const OptionsContrast = connect(mapStateToProps, sessionActions)(OptionsHideTimeRemaining);
export default OptionsContrast;
